import React, { useEffect, useState } from 'react';

interface NotebookCommentsProps {
  notebookId: string;
}

interface Comment {
  id: string;
  user: string;
  content: string;
  timestamp: string;
}

export const NotebookComments: React.FC<NotebookCommentsProps> = ({ notebookId }) => {
  const [comments, setComments] = useState<Comment[]>([]);
  const [newComment, setNewComment] = useState('');

  useEffect(() => {
    fetchComments();
    // TODO: Set up real-time updates (WebSocket/Yjs)
  }, [notebookId]);

  const fetchComments = async () => {
    // TODO: Replace with real API call
    setComments([]);
  };

  const handleAddComment = async () => {
    if (!newComment.trim()) return;
    // TODO: Replace with real API call
    setComments(prev => [
      ...prev,
      { id: Date.now().toString(), user: 'me', content: newComment, timestamp: new Date().toISOString() }
    ]);
    setNewComment('');
  };

  return (
    <div className="notebook-comments">
      <h4>Comments</h4>
      <div className="comments-list">
        {comments.map(c => (
          <div key={c.id} className="comment-block">
            <strong>{c.user}</strong> <span>({new Date(c.timestamp).toLocaleString()})</span>
            <div>{c.content}</div>
          </div>
        ))}
      </div>
      <div className="add-comment">
        <textarea
          value={newComment}
          onChange={e => setNewComment(e.target.value)}
          placeholder="Add a comment..."
        />
        <button onClick={handleAddComment}>Add Comment</button>
      </div>
    </div>
  );
}; 